var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "site-map" },
    [
      _vm.error
        ? _c("div", { staticClass: "site-map-error" }, [
            _c("i", { staticClass: "fas fa-exclamation-triangle" }),
            _vm._v(" " + _vm._s(_vm.error) + "\n    "),
          ])
        : [
            _c("div", { ref: "container", staticClass: "site-map-canvas" }),
            _vm._v(" "),
            _c("div", { staticClass: "site-map-footer" }, [
              _vm.factoryUrl
                ? _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.factoryUrl,
                        target: "_blank",
                        rel: "noopener",
                      },
                    },
                    [
                      _c("i", { staticClass: "fas fa-industry" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.factoryName) +
                          " · " +
                          _vm._s(_vm.strings.mapOpenFactory) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.legend
                ? _c(
                    "div",
                    { staticClass: "site-map-legend" },
                    [
                      _c("span", { staticClass: "legend-title" }, [
                        _vm._v(_vm._s(_vm.valueLabel)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "legend-value" }, [
                        _vm._v(_vm._s(_vm.format(_vm.legend.min))),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.legend.colours, function (colour) {
                        return _c("span", {
                          key: colour,
                          staticClass: "legend-swatch",
                          style: { background: colour },
                        })
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "legend-value" }, [
                        _vm._v(_vm._s(_vm.format(_vm.legend.max))),
                      ]),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "legend-swatch",
                        style: { background: _vm.legend.no_value },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "legend-value" }, [
                        _vm._v(_vm._s(_vm.strings.mapNoValue)),
                      ]),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }